import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AddOrganizationResultFragment = { __typename: 'Organization', id: string, legacyId: number };

export type CreateOrganizationMutationVariables = Types.Exact<{
  input: Types.MutationCreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename: 'Mutation', createOrganization: { __typename: 'Organization', id: string, legacyId: number } };

export const AddOrganizationResultFragmentDoc = gql`
    fragment AddOrganizationResult on Organization {
  id
  legacyId
}
    `;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: MutationCreateOrganizationInput!) {
  createOrganization(input: $input) {
    ...AddOrganizationResult
  }
}
    ${AddOrganizationResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrganizationGQL extends Apollo.Mutation<CreateOrganizationMutation, CreateOrganizationMutationVariables> {
    override document = CreateOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }